import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteHolidays = async (ID) => {
  try {
    const HolidayDocument = doc(db, "Holidays", ID);

    await updateDoc(HolidayDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteHolidays;
